/**
 * Ricorda in sessionStorage che in questa scheda l'audio del maxischermo è stato
 * sbloccato almeno una volta. Non aggira l'autoplay: serve solo a offrire un flusso
 * "primo tocco ovunque" al posto della barra completa dopo F5.
 */
export const SCREEN_AUDIO_UNLOCK_SESSION_KEY = 'ipb_maxi_screen_audio_unlock_v1';

export function hasScreenAudioUnlockHint(): boolean {
  try {
    return sessionStorage.getItem(SCREEN_AUDIO_UNLOCK_SESSION_KEY) === '1';
  } catch {
    return false;
  }
}

export function rememberScreenAudioUnlocked(): void {
  try {
    sessionStorage.setItem(SCREEN_AUDIO_UNLOCK_SESSION_KEY, '1');
  } catch {
    /* navigazione privata / storage disabilitato */
  }
}
